const redirectUri = `${window.location.protocol}//${window.location.host}`;
const config = {
  AUTH0: {
    domain: 'id.interviewer.ai',
    managementDomain: 'interviewer-ai-prod.auth0.com',
    clientId: 'fqkfjBMKC2TUYJzQpWzuPYTuFUfVMQ5H',
    audience: 'fqkfjBMKC2TUYJzQpWzuPYTuFUfVMQ5H', // client id
    namespace: 'https://interviewer.ai/',
    redirectUri: `${redirectUri}/callback`,
    logoutUrl: redirectUri,
  },
  // Parley support chat; the page origin must be in the workspace's allowed origins.
  PARLEY: {
    appId: 'dashboard',
    loaderUrl: 'https://chat-widget.interviewer.ai/loader.js',
  },
  TRIAL_PLAN: {
    BRONZE_TRIAL: 45,
    ENTERPRISE_TRIAL: 46,
  },
  PRICING_PLAN: {
    BRONZE: 42,
    SILVER: 43,
    GOLD: 44,
    BRONZE_TRIAL: 45,
    ENTERPRISE_TRIAL: 46,
  },
};

export default config;
